export default __webpack_public_path__ + "static/media/payment.6a7eea5e.svg";